<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/selecoes/${$route.params.idProcess}/inscricoes`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para listagem de
              inscrições</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row vld-parent" ref="subscription_container">
        <div class="col-lg-7">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Inscrição</h3>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="subscription">
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Informações básicas</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12">
                  <label class="form-control-label">Nome completo*</label>
                  <p class="description">{{ subscription.name }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label"
                    >Telefone celular (com DDD)*</label
                  >
                  <p class="description">
                    {{
                      subscription.phone
                        | VMask(
                          `(##) ####${
                            subscription.phone.length > 8 ? "#" : ""
                          }-####`
                        )
                    }}
                  </p>
                </div>
                <div class="col-lg-6">
                  <span class="form-control-label">Email*</span>
                  <p class="description">{{ subscription.email }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label">Estado*</label>
                  <p class="description">{{ subscription.state }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label">Cidade*</label>
                  <p class="description">{{ subscription.city }}</p>
                </div>
                <div class="col-lg-12">
                  <label for="" class="form-control-label d-block"
                    >LinkedIn</label
                  >
                  <p class="description">
                    {{ subscription.linkedin_url || "N/A" }}
                    <span
                      v-if="subscription.linkedin_url"
                      class="text-capitalize btn btn-link p-0 m-0 ml-1 cursor-pointer text-primary heading"
                      title="Abrir página"
                      @click="openLink(subscription.linkedin_url)"
                      ><i class="fas fa-eye"></i
                    ></span>
                  </p>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">O que você busca?</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <label class="form-control-label">
                    Selecione as opções que mais se adequam a você*
                  </label>
                </div>
                <div class="col-lg-12 mt-2 ml-lg-2">
                  <ul>
                    <li
                      v-for="(option, index) in JSON.parse(subscription.areas)"
                      :key="'area_' + index"
                    >
                      {{ option }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Dados pessoais</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-6">
                  <label class="form-control-label"
                    >Com qual identidade de gênero você se identifica?*</label
                  >
                  <p class="description">{{ subscription.gender }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label">Estado civil*</label>
                  <p class="description">{{ subscription.civil_status }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label">Data de nascimento*</label>
                  <p class="description">
                    {{ formatDate(subscription.birthday) }} ({{
                      getAge(subscription.birthday)
                    }}
                    anos)
                  </p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label">Nacionalidade*</label>
                  <p class="description">{{ subscription.nationality }}</p>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block"
                    >Site pessoal ou blog (caso tenha)</label
                  >
                  <p class="description">
                    {{ subscription.homepage_url || "N/A" }}
                  </p>
                  <span
                    v-if="subscription.homepage_url"
                    class="text-capitalize btn btn-link p-0 m-0 ml-1 cursor-pointer text-primary heading"
                    title="Abrir página"
                    @click="openLink(subscription.homepage_url)"
                    ><i class="fas fa-eye"></i
                  ></span>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label d-block"
                    >GitHub (opcional caso seja programador)</label
                  >
                  <p class="description">
                    {{ subscription.github_url || "N/A" }}
                  </p>
                  <span
                    v-if="subscription.github_url"
                    class="text-capitalize btn btn-link p-0 m-0 ml-1 cursor-pointer text-primary heading"
                    title="Abrir página"
                    @click="openLink(subscription.github_url)"
                    ><i class="fas fa-eye"></i
                  ></span>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Formação</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div
                  class="col-12"
                  v-for="(ed, index) in JSON.parse(subscription.education)"
                  :key="'ed_' + index"
                >
                  <div class="row" v-if="index > 0">
                    <div class="col-6 offset-3">
                      <hr class="my-2" />
                    </div>
                  </div>
                  <p class="description">
                    Formação {{ index + 1 }}<b v-if="index === 0">*</b>
                  </p>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Curso</label>
                      <p class="description">{{ ed.course }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block"
                        >Instituição)</label
                      >
                      <p class="description">{{ ed.institution }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Início</label>
                      <p class="description">{{ formatMonthYear(ed.start) }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Término</label>
                      <p class="description">{{ formatMonthYear(ed.end) }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Duração</label>
                      <p class="description">{{ ed.duration }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Situação</label>
                      <p class="description">{{ ed.status }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Resumo profissional</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div
                  v-for="(ex, index) in JSON.parse(subscription.experiences)"
                  :key="'ex_' + index"
                  class="col-12"
                >
                  <div class="row" v-if="index > 0">
                    <div class="col-6 offset-3">
                      <hr class="my-2" />
                    </div>
                  </div>
                  <p class="description">
                    Experiência profissional {{ index + 1 }}
                  </p>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Cargo</label>
                      <p class="description">{{ ex.position }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Empresa</label>
                      <p class="description">{{ ex.company }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Início</label>
                      <p class="description">{{ formatMonthYear(ex.start) }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Término</label>
                      <p class="description">{{ formatMonthYear(ex.end) }}</p>
                    </div>
                    <div class="col-lg-12">
                      <label class="form-control-label d-block"
                        >Atribuições</label
                      >
                      <p class="description">{{ ex.attributions }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Idiomas</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div
                  v-for="(id, index) in JSON.parse(subscription.languages)"
                  :key="'id_' + index"
                  class="col-12"
                >
                  <div class="row" v-if="index > 0">
                    <div class="col-6 offset-3">
                      <hr class="my-2" />
                    </div>
                  </div>
                  <p class="description">Idioma {{ index + 1 }}</p>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label d-block">Idioma</label>
                      <p class="description">{{ id.language }}</p>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block"
                        >Nível de proeficiência</label
                      >
                      <p class="description">{{ id.level }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">Portifólio</h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <p>
                    Você tem um portfólio e gostaria de compartilhar conosco?
                  </p>
                  <div>
                    <p v-if="subscription.portfolio_url" class="description">
                      <span
                        class="text-capitalize btn btn-link p-0 m-0 cursor-pointer text-primary heading"
                        title="Abrir página"
                        @click="openLink(subscription.portfolio_url)"
                        >Visualizar</span
                      >
                    </p>
                    <p v-else class="description">N/A</p>
                  </div>
                  <p class="description text-muted">
                    <i class="fas fa-image mr-2"></i>
                    deve ser do formato
                    <b class="font-weight-bold">PDF</b> e ter um tamanho máximo
                    de <b class="font-weight-bold">10MB</b>.
                  </p>
                </div>
              </div>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="heading-small text-muted">
                    Informações complementares
                  </h6>
                </div>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <p>
                    Deseja adicionar alguma informação? (até 1.500 caracteres)
                  </p>
                  <div class="col-lg-12">
                    <p class="description">{{ subscription.note || "N/A" }}</p>
                    <p class="description mb-1 text-right">
                      <b>{{ 1500 - subscription.note.length }}</b> caracteres
                      restantes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-5 mt-4 mt-lg-0">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Teste de Perfil comportamental (DISC)</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <p>
                Confira abaixo o resultado do teste de perfil comportamental. O
                método DISC compreende que existem quatro perfis de
                comportamentos que predomina entre os indivíduos:
                <b>Dominante</b>, <b>Influente</b>, <b>Estável</b> e
                <b>Condescendente</b>.
              </p>
              <apexchart
                class="border rounded my-3"
                :height="400"
                :options="chartOptions"
                :series="chartSeries"
              ></apexchart>
              <img
                src="/img/pages/disc_tbl.png"
                class="img-fluid border rounded"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

import api from "@/services/api.js";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      subscription: "",
      chartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        title: { text: "DISC - Perfil comportamental" },
      },
      chartSeries: [],
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.subscription_container,
      width: 140,
      height: 140,
    });
    try {
      const { data } = await api.get(
        `/adm/recruitment-processes/${this.$route.params.idProcess}/subscriptions/${this.$route.params.idSubscription}`
      );
      this.subscription = data;
      const disc = JSON.parse(data.disc);
      const discResult = [
        {
          x: "Dominante",
          y: disc.reduce((acc, q) => acc + Number(q[0]), 0),
          fillColor: "#FF0000",
        },
        {
          x: "Influente",
          y: disc.reduce((acc, q) => acc + Number(q[1]), 0),
          fillColor: "#EDD42F",
        },
        {
          x: "Estável",
          y: disc.reduce((acc, q) => acc + Number(q[2]), 0),
          fillColor: "#0A820A",
        },
        {
          x: "Condescendente",
          y: disc.reduce((acc, q) => acc + Number(q[3]), 0),
          fillColor: "#0000FF",
        },
      ];
      this.chartSeries.push({
        name: "Pontuação",
        data: discResult,
      });
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push(
        `/admin/selecoes/${this.$route.params.idProcess}/inscricoes`
      );
    }
    loader.hide();
  },
  methods: {
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
    formatMonthYear(rawDate, format = "MMMM [de] YYYY") {
      return this.moment(rawDate, "YYYY-MM").locale("pt-br").format(format);
    },
  },
};
</script>
